// extracted by mini-css-extract-plugin
export default {"storeContainer":"pXLPf","storeContainerTitle":"s88OZ"};